<template>
  <div
    class="post-comment-item"
    :class="{ fromZoom }"
  >
    <div
      v-if="isTabletLandscape || isDesktop"
      class="img-container"
    >
      <NuxtImg
        v-if="comment.user?.avatar"
        :src="comment.user.avatar.url"
        :alt="`photo de profil de ${comment.user.nickname}`"
        loading="lazy"
        quality="80"
        width="54"
        height="54"
        sizes="sm:54px tb:108px"
        fit="cover"
        format="auto"
      />
    </div>
    <div class="text-container">
      <div class="name-container">
        <div v-show="isMobile || isLargeMobile || isTabletPortrait">
          <div class="img-container">
            <NuxtImg
              v-if="comment.user?.avatar"
              :src="comment.user.avatar.url"
              :alt="`photo de profil de ${comment.user.nickname}`"
              loading="lazy"
              quality="80"
              width="54"
              height="54"
              sizes="sm:54px tb:108px"
              fit="cover"
              format="auto"
            />
          </div>
        </div>
        <p class="name">
          {{ readMore(capitalize(comment.user?.nickname), 25) }}
        </p>
      </div>
      <div
        class="content"
        v-html="contentParsed"
      />
      <div class="actions">
        <div class="row">
          <time
            class="date"
            :datetime="comment.created_at"
          >
            {{ dateToMoment(comment.created_at) }}
          </time>
          <div
            v-if="!comment.idParent"
            class="comments"
          >
            <img
              src="~assets/icons/comment.svg"
              alt="commentaires"
            />
            {{ comment.children ? comment.comments_count : 0 }}
          </div>
          <div
            class="likes"
            :class="{ isLiked: comment.is_liked }"
            @click="tryLikeComment"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.804"
              height="15.731"
              viewBox="0 0 17.804 15.731"
            >
              <path
                d="M17.804 7.615a2.188 2.188 0 0 1-.109.333c-.1.2-.219.383-.323.578a.247.247 0 0 0-.039.178 1.765 1.765 0 0 1-.292 1.8.193.193 0 0 0-.041.218 1.727 1.727 0 0 1-.232 1.683.422.422 0 0 0-.084.387 1.888 1.888 0 0 1-.446 1.853 1.635 1.635 0 0 1-.892.474 5.151 5.151 0 0 1-.915.1H7.655a2.075 2.075 0 0 1-1.143-.373.428.428 0 0 0-.339-.086 2.441 2.441 0 0 1-.027.326.713.713 0 0 1-.654.64 1.408 1.408 0 0 1-.155 0H.827a.763.763 0 0 1-.823-.7V7.928a.795.795 0 0 1 .835-.845h5.088a2.851 2.851 0 0 1 .357.068.243.243 0 0 0 .178-.021 5.533 5.533 0 0 0 .519-.58 23.722 23.722 0 0 0 1.851-3.04 1.1 1.1 0 0 0 .134-.569c-.023-.587-.023-1.176-.047-1.762a.974.974 0 0 1 .515-.927 1.9 1.9 0 0 1 2.063.114 1.176 1.176 0 0 1 .322.475c.219.535.428 1.082.613 1.633a3.532 3.532 0 0 1 .075 1.851c-.093.469-.16.943-.241 1.414-.027.16-.021.178.143.178h3.854a1.649 1.649 0 0 1 .892.212 1.347 1.347 0 0 1 .594.849c.014.055.032.109.048.162v.483Zm-6.457-.963c.139-.826.28-1.633.408-2.441a3.594 3.594 0 0 0 .08-.87 7.146 7.146 0 0 0-.7-2.2.535.535 0 0 0-.4-.357 1.206 1.206 0 0 0-.892.078.319.319 0 0 0-.194.325q.036.974.036 1.947a1.325 1.325 0 0 1-.077.455 3.122 3.122 0 0 1-.26.535c-.535.876-1.07 1.755-1.619 2.62a3.355 3.355 0 0 1-.958 1.07c-.253.164-.508.332-.754.5a.242.242 0 0 0-.1.164v5.289c0 .105.045.116.136.127a2.569 2.569 0 0 1 .506.105 1.4 1.4 0 0 1 .316.191 1.577 1.577 0 0 0 .909.273h6.712a3.057 3.057 0 0 0 .4-.023 1.163 1.163 0 0 0 .824-.476.815.815 0 0 0 .046-1 2.173 2.173 0 0 0-.412-.312.32.32 0 0 1 .114-.123 1.154 1.154 0 0 0 .831-.8.722.722 0 0 0-.228-.829 2.965 2.965 0 0 0-.4-.219.513.513 0 0 1 .159-.153 1.1 1.1 0 0 0 .678-.483.783.783 0 0 0-.357-1.273.155.155 0 0 1-.093-.1.132.132 0 0 1 .114-.148 1.109 1.109 0 0 0 .851-.958.713.713 0 0 0-.389-.822 1.307 1.307 0 0 0-.5-.093h-4.8ZM5.26 7.841c-.057 0-.1-.009-.141-.009H.897a.123.123 0 0 0-.152.153v6.856a.135.135 0 0 0 .166.168h4.166c.178 0 .178 0 .178-.187V7.846Z"
                fill="#363636"
              />
            </svg>
            {{ comment.likes_count }}
          </div>
        </div>
        <div class="row">
          <div
            class="like"
            :class="{ isLiked: comment.is_liked }"
            @click="tryLikeComment"
          >
            J'aime
          </div>
          <div
            class="answer"
            @click="openCommentEditor"
          >
            Répondre
          </div>
          <div
            class="report"
            @click="reportComment"
          >
            Signaler
          </div>
        </div>
      </div>
      <div
        v-if="comment.children"
        class="answers"
      >
        <div
          v-if="comment.children.length && !comment.isOpen"
          class="more show"
          @click="toggleAnswers(comment)"
        >
          Afficher les réponses
          <img
            src="~/assets/icons/down.svg"
            alt=""
          />
        </div>
        <div
          v-if="comment.isOpen"
          class="more hide"
          @click="toggleAnswers(comment)"
        >
          Masquer les réponses
          <img
            src="~/assets/icons/up.svg"
            alt=""
          />
        </div>
        <div
          v-if="comment.isOpen"
          class="answers-container"
        >
          <PostCommentItem
            v-for="(answer, index) in comment.children"
            :key="answer.id"
            :comment="{
              ...answer,
              idParent: comment.id,
              slugType: comment.slugType,
              slugParent: comment.slugParent,
              parentHasMoreComments: comment.has_more_comments,
              last: index == comment.children.length - 1 ? true : false,
            }"
            :from-zoom="fromZoom"
          />
        </div>
      </div>
      <div
        v-if="answerComment"
        class="editor-comment"
      >
        <h2 class="title-strat">Votre commentaire</h2>
        <div class="comment-section">
          <div
            v-if="auth.data.value?.avatar"
            class="user-image"
          >
            <NuxtImg
              :src="auth.data.value?.avatar.url"
              alt=""
              loading="lazy"
              quality="80"
              width="54"
              height="54"
              sizes="sm:54px tb:108px"
              fit="cover"
              format="auto"
            />
          </div>
          <div class="editor-content">
            <TheEditor
              ref="editorComment"
              v-model="contentEditorComment"
              :list="false"
              :mention="true"
              :wapers-suggestions="wapersSuggestions"
            />
            <span
              v-if="errors.content"
              class="c-form__feedback is-invalid"
            >
              {{ errors.content }}
            </span>
          </div>
        </div>
        <div
          class="button"
          :class="{ disabled: !canComment }"
          @click="submitComment"
        >
          Publier
        </div>
      </div>
      <div
        v-if="comment.idParent && comment.parentHasMoreComments && comment.last"
        class="more fromChild"
        @click="showMoreSubComment"
      >
        Plus de réponses
        <img
          src="~/assets/icons/down.svg"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TheEditor from '@/components/shared/Editor/TheEditor.vue'
import { checkLoginModal } from '~/modals/checkLogin'
import { getReportModal } from '~/modals/report'
import type { FormattedCustomComment } from '~/types'

const props = withDefaults(
  defineProps<{
    comment: FormattedCustomComment & { slugParent?: string; slugType?: string }
    fromZoom?: boolean
  }>(),
  {
    fromZoom: false,
  },
)

const auth = useAuth()

const {
  isMobile,
  isLargeMobile,
  isTabletLandscape,
  isTabletPortrait,
  isDesktop,
} = useCustomMediaQuery()

const wapersStore = useWapersStore()

const wapersSuggestions = computed(() => {
  return wapersStore.userWapers.map((waper, index) => {
    return {
      id: index,
      name: waper.nickname,
      userId: waper.id,
      slug: waper.slug,
    }
  })
})

const socialStore = useSocialStore()
const socialContestStore = useSocialContestStore()

const usedStore = computed(() => {
  return props.fromZoom ? socialContestStore : socialStore
})

const toggleAnswers = (comment: FormattedCustomComment) => {
  usedStore.value.changeStatusComment({
    idComment: comment.id,
    status: !comment.isOpen,
  })
}

const contentParsed = computed(() => {
  let content = props.comment.content

  if (props.comment?.content_images?.length) {
    props.comment.content_images.forEach((image, index) => {
      if (content) {
        content = content.replace(
          `<!-- contentImage${index + 1} -->`,
          `<img src="${image.url}" loading="lazy" alt=""> `,
        )
      }
    })
  }

  if (props.comment.content_embed && content) {
    content = content.replace(
      '<!-- contentEmbed -->',
      `<iframe src="${props.comment.content_embed}" frameborder="0" allowfullscreen="true" contenteditable="false" draggable="true" loading="lazy"></iframe> `,
    )
  }

  content = linkify(content)

  return content
})

const { authenticated } = useAuthenticated()

const tryLikeComment = async () => {
  if (!authenticated.value) return checkLoginModal.open()

  const payload = {
    idComment: props.comment.id,
    idParent: props.comment.idParent,
  }
  if (props.comment.is_liked) {
    return usedStore.value.unlikeComment(payload)
  }
  return usedStore.value.likeComment(payload)
}

const showMoreSubComment = () => {
  return usedStore.value.showMoreContent({ parentId: props.comment.idParent })
}

const canComment = ref(true)

const errors = ref<{
  [key: string]: unknown
  content?: string
}>({})
const contentEditorComment = ref('')
const editorComment = ref<InstanceType<typeof TheEditor> | null>(null)
const answerComment = ref(false)

const submitComment = async () => {
  if (!canComment.value) return

  canComment.value = false
  errors.value = {}

  type ContentImageKey = `contentImage${number}`
  const formData = {
    content: contentEditorComment.value,
    parent: props.comment.idParent ?? props.comment.id,
  } as {
    content: string
    parent?: string
    [key: ContentImageKey]: string | undefined
  }

  const images = formData.content.match(
    /<img\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?>/g,
  )

  if (images?.length) {
    images.forEach((image, index) => {
      formData.content = formData.content.replace(
        image,
        `<!-- contentImage${index + 1} -->`,
      )
      formData[`contentImage${index + 1}`] = image.match(
        /<img\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?>/,
      )?.[1]
    })
  }

  const { error } = await usedStore.value.postCommentContent({
    content: formData,
  })

  if (error) {
    const { statusCode, data } = error

    if (data.errors && statusCode && statusCode >= 400 && statusCode < 500) {
      Object.keys(data.errors).forEach((key) => {
        errors.value = {
          ...errors.value,
          [key]: data.errors[key].join(' '),
        }
      })
    }

    canComment.value = true
  }

  editorComment.value?.editor?.commands.clearContent()
  contentEditorComment.value = ''
  answerComment.value = false
  canComment.value = true
}

const { gtag } = useGtag()

const openCommentEditor = async () => {
  if (!authenticated.value) return checkLoginModal.open()

  gtag('event', 'social', {
    interaction: 'comment',
    target_url: props.comment.slugParent,
  })

  answerComment.value = !answerComment.value

  if (!answerComment.value) return

  await nextTick()
  editorComment.value?.editor?.commands.focus()
}

const reportModal = getReportModal({
  type: 'comment',
  slug: (props.comment.id ?? '').toString(),
})

const reportComment = async () => {
  return authenticated.value ? reportModal.open() : checkLoginModal.open()
}
</script>

<style lang="scss">
.post-comment-item {
  display: flex;
  padding: 2rem 0;
  text-align: left;
  border-top: 1px solid rgba($black, 0.2);

  &.fromZoom {
    .text-container {
      .actions {
        flex-direction: column;

        .like {
          margin-left: 0;
        }

        .row:first-child {
          margin-bottom: 5px;
        }
      }
    }
  }

  .isLiked {
    color: $blue;

    svg {
      path {
        fill: $blue;
      }
    }
  }

  .more {
    margin-top: 1rem;
    color: $blue;
    cursor: pointer;

    img {
      margin-left: 1rem;
    }
  }

  .editor-comment {
    display: flex;
    flex-direction: column;
    padding: 3rem 0;

    .comment-section {
      display: flex;
      width: 100%;
      margin-top: 2rem;
    }

    .user-image {
      width: 5.4rem;
      height: 5.4rem;
      margin-right: 3rem;
      overflow: hidden;
      background: #ccc;
      border-radius: 50%;

      @media screen and (max-width: 430px) {
        display: none;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .editor-content {
      width: 100%;
    }

    .button {
      display: inline-flex;
      align-items: center;
      align-self: flex-end;
      height: 4.6rem;
      margin-top: 3rem;
      padding: 0 2rem;
      color: $white;
      font-size: 1.5rem;
      font-weight: 500;
      background: $backgroundBlue;
      cursor: pointer;

      &.disabled {
        background-color: $lightGrey;
        cursor: not-allowed;
        opacity: 1;
      }
    }
  }

  .img-container {
    flex-shrink: 0;
    width: 5.4rem;
    height: 5.4rem;
    margin-right: 3rem;
    margin-bottom: 1.7rem;
    overflow: hidden;
    background: #ccc;
    border-radius: 2.8rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .text-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .name-container {
      margin-bottom: 1rem;
    }

    .name {
      font-size: 1.6rem;
      font-weight: bold;
      line-height: 2.1rem;
    }

    .content {
      margin-bottom: 1rem;

      p {
        margin-bottom: 2rem;

        a {
          line-break: anywhere;
        }
      }

      img {
        display: block;
        width: 100% !important;
        height: auto !important;
        margin: 4rem 0;
      }

      iframe {
        display: block;
        width: 100%;
        height: 40rem;
        margin-bottom: 4rem;
      }

      a {
        margin: inherit;
        padding-left: 0;
        color: $blue;
        font-size: 1.4rem;
        text-decoration: none;
      }
    }

    .actions {
      display: flex;
      justify-content: space-between;
      color: #999;
      font-size: 1.2rem;
      line-height: 1.6rem;

      .row {
        display: flex;
      }

      .comments {
        margin-left: 4rem;
        font-weight: 500;

        img {
          width: 1.3rem;
          height: 1.1rem;
          margin-right: 0.9rem;
        }
      }

      .likes {
        margin-left: 2rem;
        font-weight: 500;
        cursor: pointer;

        svg {
          width: 1.01rem;
          height: 1.1rem;
          margin-right: 0.9rem;
        }
      }

      .like,
      .answer,
      .report {
        margin-left: 2rem;
        cursor: pointer;

        &:hover {
          color: $blue;
        }
      }
    }

    .answers {
      .post-comment-item {
        padding-bottom: 0;
        border-top: none;
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .post-comment-item {
    display: flex;
    flex-direction: column;
    padding: 2rem 0;
    text-align: left;
    border-top: 1px solid rgba($black, 0.2);

    .text-container {
      .name-container {
        display: flex;
        align-items: center;

        .img-container {
          margin-right: 2rem;
          margin-bottom: 0;
        }
      }

      .actions {
        flex-direction: column;

        .like {
          margin-left: 0;
        }

        .row:last-child {
          margin-top: 1rem;
        }
      }

      .answers {
        padding-left: 2.5rem;
      }
    }
  }
}

.is-invalid {
  display: block;
  color: #ea5151;
}
</style>
